
import translate from 'src/core/services/translate';
import { IMPERIAL } from 'src/vendors/constants';

export const getMeasurementType = (systemOfMeasurementId?: number) =>
  systemOfMeasurementId && translate(`common.speedUnit.${systemOfMeasurementId === IMPERIAL ? 'MPH' : 'KPH'}`);
